module.exports = __webpack_public_path__ + "img/info_sample01.0a0fc710.png";